<template>
    <div class="platform-section mt-12 pt-12">
      <div class="text-h3 font-weight-bold py-3 mt-12" v-html="$t('home.platforms.title')"></div>
      <div class="text-h5  grey--text py-3 pb-12" v-html="$t('home.platforms.subtitle')"></div>
      <v-row>
        <v-col cols="12" md="4" sm="12">
          <v-card elevation="0" color="#E7EBF5" class="pa-6">
            <v-card-title>
              <div class="primary--text">
                <v-img src="@/assets/market-place.svg" contain height="400" width="calc(100% - 16px)" class="my-9 mx-n3"></v-img>
                <div class="d-flex"><v-img src="@/assets/cda.svg" max-width="22" contain class="mr-2"></v-img> {{ $t('home.platforms.marketplace.title') }}</div>

              </div>
            </v-card-title>
            <v-card-text>
              <div v-html="$t('home.platforms.marketplace.subtitle')"></div>
              <v-btn text class="mt-6 ml-n4 font-weight-bold" :href="$t('home.platforms.marketplace.link')" target="_blank">{{ $t('home.platforms.cta') }} <v-icon small class="ml-6">mdi-arrow-right</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <v-card elevation="0" color="#E7EBF5" class="pa-6">
            <v-card-title>
              <div class="primary--text">
                <v-img src="@/assets/saas.svg" contain height="400" width="calc(100% - 16px)" class="my-9  mx-n3"></v-img>
                <div class="d-flex"><v-img src="@/assets/cdm.svg" max-width="22" contain class="mr-2"></v-img> {{ $t('home.platforms.saas.title') }}</div>
              </div>
            </v-card-title>
            <v-card-text>
              <div v-html="$t('home.platforms.saas.subtitle')"></div>
              <v-btn text class="mt-6 ml-n4 font-weight-bold" :href="$t('home.platforms.saas.link')" target="_blank">{{ $t('home.platforms.cta') }} <v-icon small class="ml-6">mdi-arrow-right</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="12">
          <v-card elevation="0" color="#E7EBF5" class="pa-6">
            <v-card-title>
              <div class="primary--text">
                <v-img src="@/assets/white-label.svg" contain height="400" width="calc(100% - 16px)" class="my-9  mx-n3"></v-img>
                <div class="d-flex"><v-icon class="mr-2">mdi-application-braces-outline</v-icon> {{ $t('home.platforms.whitelabel.title') }}</div>

              </div>
            </v-card-title>
            <v-card-text>
              <div v-html="$t('home.platforms.whitelabel.subtitle')" style="min-height: 66px"></div>
              <v-btn text class="mt-6 ml-n4 font-weight-bold" :to="$t('home.platforms.whitelabel.link')">{{ $t('home.platforms.cta') }} <v-icon small class="ml-6">mdi-arrow-right</v-icon></v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
        
    </div>
</template>
<script>
export default {
    name: "CoverSection"
}
</script>